import { operationPrice } from '@/utils/commercialOperation'

export default {
  computed: {
    displaysBeforeTax() {
      return Boolean(
        this.$auth.loggedIn &&
          (!this.$store.getters.show_vat || this.$store.getters.is_pro)
      )
    },
  },
  methods: {
    operationPriceOf(product, { beforeTax = this.displaysBeforeTax } = {}) {
      return operationPrice({
        operation: this.$store.state.commercial_operation,
        now: this.$store.state.clock_now,
        visitor: { loggedIn: this.$auth.loggedIn, user: this.$auth.user },
        product,
        variant: product?.variant,
        beforeTax,
        vatRate: this.$store.state.vat_rate ?? 20,
      })
    },
    operationPricesOf(products) {
      return Object.fromEntries(
        (products ?? []).map(product => [
          product.id,
          this.operationPriceOf(product),
        ])
      )
    },
    trackOperationBadgeProductClick(product, price) {
      if (price) this.$trackOperationBadgeProductClick?.(product, price.code)
    },
  },
}
